class ClassNamesService {
  static execute(list) {
    return list.filter(condition => condition).join(' ')
  }
}

export default ClassNamesService
